import { all, call, put, takeLatest } from 'redux-saga/effects';
import api from '../../services/api';
import types from '../types';
import notification from '../../services/notification';

function* getPosts({ payload }) {
  try {
    const { data, status } = yield call(api.posts.getPosts, payload);
    if (status < 200 && status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.GET_POSTS_SUCCESS, payload: data });
  } catch (error) {
    yield put({ type: types.GET_POSTS_FAILURE });
    if (error?.response?.status === 401) return;
    notification({
      message: error?.response?.data?.errors?.length
        ? error?.response?.data?.errors[0].replace(/_/g, ' ')
        : 'Something went wrong',
    });
  }
}

function* getSinglePost({ payload }) {
  try {
    const { data, status } = yield call(api.posts.getSinglePost, payload);
    if (status < 200 && status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.GET_SINGLE_POST_SUCCESS, payload: data });
  } catch (error) {
    yield put({ type: types.GET_SINGLE_POST_FAILURE });
    if (error?.response?.status === 401) return;
    notification({
      message: error?.response?.data?.errors?.length
        ? error?.response?.data?.errors[0].replace(/_/g, ' ')
        : 'Something went wrong',
    });
  }
}

function* createPost({ payload, callback }) {
  try {
    const { data, status } = yield call(api.posts.createPost, payload);
    if (status < 200 && status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.CREATE_POST_SUCCESS, payload: data });
    notification({ type: 'success', message: 'Success' });
    callback();
  } catch (error) {
    yield put({ type: types.CREATE_POST_FAILURE });
    if (error?.response?.status === 401) return;

    if (
      error?.response?.data?.errors &&
      error?.response?.data?.errors?.title[0]?.includes(
        'the_title_has_already_been_taken',
      )
    ) {
      notification({
        type: 'error',
        title: 'Blog',
        message: 'The title has already been taken',
      });
      return;
    }

    notification({
      message: error?.response?.data?.errors?.length
        ? error?.response?.data?.errors[0].replace(/_/g, ' ')
        : 'Something went wrong',
    });
  }
}

function* updatePost({ payload, callback }) {
  try {
    const { status } = yield call(api.posts.updatePost, payload);
    if (status < 200 && status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.UPDATE_POST_SUCCESS });
    notification({ type: 'success', message: 'Success' });
    callback();
  } catch (error) {
    yield put({ type: types.UPDATE_POST_FAILURE });
    if (error?.response?.status === 401) return;
    notification({
      message: error?.response?.data?.errors?.length
        ? error?.response?.data?.errors[0].replace(/_/g, ' ')
        : 'Something went wrong',
    });
  }
}

function* deletePost({ payload }) {
  try {
    const { status } = yield call(api.posts.deletePost, payload);
    if (status < 200 && status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.DELETE_POST_SUCCESS, payload: payload.id });
  } catch (error) {
    yield put({ type: types.DELETE_POST_FAILURE });
    if (error?.response?.status === 401) return;
    notification({
      message: error?.response?.data?.errors?.length
        ? error?.response?.data?.errors[0].replace(/_/g, ' ')
        : 'Something went wrong',
    });
  }
}

function* createPostContent({ payload, callback }) {
  try {
    const { data, status } = yield call(api.posts.createPostContent, payload);
    if (status < 200 && status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.CREATE_POST_CONTENT_SUCCESS, payload: data });
    notification({ type: 'success', message: 'Success' });
    callback();
  } catch (error) {
    yield put({ type: types.CREATE_POST_CONTENT_FAILURE });
    if (error?.response?.status === 401) return;
    notification({
      message: error?.response?.data?.errors?.length
        ? error?.response?.data?.errors[0].replace(/_/g, ' ')
        : 'Something went wrong',
    });
  }
}

function* updatePostContent({ payload, callback }) {
  try {
    const { data, status } = yield call(api.posts.updatePostContent, payload);
    if (status < 200 && status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.UPDATE_POST_CONTENT_SUCCESS, payload: data });
    notification({ type: 'success', message: 'Success' });
    callback();
  } catch (error) {
    yield put({ type: types.UPDATE_POST_CONTENT_FAILURE });
    if (error?.response?.status === 401) return;
    notification({
      message: error?.response?.data?.errors?.length
        ? error?.response?.data?.errors[0].replace(/_/g, ' ')
        : 'Something went wrong',
    });
  }
}

function* deletePostContent({ payload }) {
  try {
    const { status } = yield call(api.posts.deletePostContent, payload);
    if (status < 200 && status >= 300) throw new Error('Something went wrong');
  } catch (error) {
    yield put({ type: types.DELETE_POST_CONTENT_FAILURE });
    if (error?.response?.status === 401) return;
    notification({
      message: error?.response?.data?.errors?.length
        ? error?.response?.data?.errors[0].replace(/_/g, ' ')
        : 'Something went wrong',
    });
  }
}

function* getCategories({ payload }) {
  try {
    const { data, status } = yield call(api.posts.getCategoryList, payload);
    if (status < 200 && status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.GET_CATEGORIES_SUCCESS, payload: data });
  } catch (error) {
    yield put({ type: types.GET_CATEGORIES_FAILURE });
    if (error?.response?.status === 401) return;
    notification({
      message: error?.response?.data?.errors?.length
        ? error?.response?.data?.errors[0].replace(/_/g, ' ')
        : 'Something went wrong',
    });
  }
}
function* getSingleCategory({ payload }) {
  try {
    const { data, status } = yield call(api.posts.getSingleCategory, payload);
    if (status < 200 && status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.GET_SINGLE_CATEGORY_SUCCESS, payload: data });
  } catch (error) {
    yield put({ type: types.GET_SINGLE_CATEGORY_FAILURE });
    if (error?.response?.status === 401) return;
    notification({
      message: error?.response?.data?.errors?.length
        ? error?.response?.data?.errors[0].replace(/_/g, ' ')
        : 'Something went wrong',
    });
  }
}

function* createCategory({ payload, callback }) {
  try {
    const { data, status } = yield call(api.posts.createCategory, payload);
    if (status < 200 && status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.CREATE_CATEGORY_SUCCESS, payload: data });
    notification({ type: 'success', message: 'Success' });
    callback();
  } catch (error) {
    yield put({ type: types.CREATE_CATEGORY_FAILURE });
    if (error?.response?.status === 401) return;
    notification({
      message: error?.response?.data?.errors?.length
        ? error?.response?.data?.errors[0].replace(/_/g, ' ')
        : 'Something went wrong',
    });
  }
}

function* updateCategory({ payload, callback }) {
  try {
    const { status } = yield call(api.posts.updateCategory, payload);
    if (status < 200 && status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.UPDATE_CATEGORY_SUCCESS });
    notification({ type: 'success', message: 'Success' });
    callback();
  } catch (error) {
    yield put({ type: types.UPDATE_CATEGORY_FAILURE });
    if (error?.response?.status === 401) return;
    notification({
      message: error?.response?.data?.errors?.length
        ? error?.response?.data?.errors[0].replace(/_/g, ' ')
        : 'Something went wrong',
    });
  }
}

function* deleteCategory({ payload }) {
  try {
    const { status } = yield call(api.posts.deleteCategory, payload);
    if (status < 200 && status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.DELETE_CATEGORY_SUCCESS, payload: payload.id });
  } catch (error) {
    yield put({ type: types.DELETE_CATEGORY_FAILURE });
    if (error?.response?.status === 401) return;
    notification({
      message: error?.response?.data?.errors?.length
        ? error?.response?.data?.errors[0].replace(/_/g, ' ')
        : 'Something went wrong',
    });
  }
}

function* createCategoryContent({ payload, callback }) {
  try {
    const { data, status } = yield call(api.posts.createCategoryContent, payload);
    if (status < 200 && status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.CREATE_CATEGORY_CONTENT_SUCCESS, payload: data });
    notification({ type: 'success', message: 'Success' });
    callback();
  } catch (error) {
    yield put({ type: types.CREATE_CATEGORY_CONTENT_FAILURE });
    if (error?.response?.status === 401) return;
    notification({
      message: error?.response?.data?.errors?.length
        ? error?.response?.data?.errors[0].replace(/_/g, ' ')
        : 'Something went wrong',
    });
  }
}

function* updateCategoryContent({ payload, callback }) {
  try {
    const { data, status } = yield call(api.posts.updateCategoryContent, payload);
    if (status < 200 && status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.UPDATE_CATEGORY_CONTENT_SUCCESS, payload: data });
    notification({ type: 'success', message: 'Success' });
    callback();
  } catch (error) {
    yield put({ type: types.UPDATE_CATEGORY_CONTENT_FAILURE });
    if (error?.response?.status === 401) return;
    notification({
      message: error?.response?.data?.errors?.length
        ? error?.response?.data?.errors[0].replace(/_/g, ' ')
        : 'Something went wrong',
    });
  }
}

function* deleteCategoryContent({ payload }) {
  try {
    const { status } = yield call(api.posts.deleteCategoryContent, payload);
    if (status < 200 && status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.DELETE_CATEGORY_CONTENT_SUCCESS });
  } catch (error) {
    yield put({ type: types.DELETE_CATEGORY_CONTENT_FAILURE });
    if (error?.response?.status === 401) return;
    notification({
      message: error?.response?.data?.errors?.length
        ? error?.response?.data?.errors[0].replace(/_/g, ' ')
        : 'Something went wrong',
    });
  }
}

export function* posts() {
  yield all([
    takeLatest(types.GET_POSTS_START, getPosts),
    takeLatest(types.GET_SINGLE_POST_START, getSinglePost),
    takeLatest(types.CREATE_POST_START, createPost),
    takeLatest(types.UPDATE_POST_START, updatePost),
    takeLatest(types.DELETE_POST_START, deletePost),
    takeLatest(types.CREATE_POST_CONTENT_START, createPostContent),
    takeLatest(types.UPDATE_POST_CONTENT_START, updatePostContent),
    takeLatest(types.DELETE_POST_CONTENT_START, deletePostContent),

    takeLatest(types.GET_CATEGORIES_START, getCategories),
    takeLatest(types.GET_SINGLE_CATEGORY_START, getSingleCategory),
    takeLatest(types.CREATE_CATEGORY_CONTENT_START, createCategoryContent),
    takeLatest(types.UPDATE_CATEGORY_CONTENT_START, updateCategoryContent),
    takeLatest(types.DELETE_CATEGORY_CONTENT_START, deleteCategoryContent),
    takeLatest(types.CREATE_CATEGORY_START, createCategory),
    takeLatest(types.DELETE_CATEGORY_START, deleteCategory),
    takeLatest(types.UPDATE_CATEGORY_START, updateCategory),
  ]);
}
